import $ from "jquery";
import size from '../base/_size';
import debug from 'bows/dist/bows.min.js';


let $testimonial = $('[data-slider="testimonial"]');


const $body = $('body');
const log = debug("sliders:testimonial");



function sliderInit() {
	$testimonial.each(function () {
		let $this = $(this);
		let role = $this.attr('role');
		let $testimonial = $this.closest('.testimonial-slider');
		let $sb = $testimonial.find('.slider-nav__arrows');
		let slider = '';

		if (role !== 'region') {
			slider = $this.slick({
				dots: false,
				mobileFirst: true,
				speed: 500,
				infinite: true,
				arrows: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				appendArrows: $sb,
			});
			window.sliderArray.push(slider);
		}
	});

}


export function init() {
	if ($testimonial.length) {
		sliderInit();
	}
}

export default {
	init
};
